import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import ReplayPlayer from 'components/UI/Replays/ReplayPlayer';

const styles = theme => ({
  root: {
  },
  itemTheme: {
    textAlign: 'left'
  },
  itemTitle: {
    textAlign: 'left'
  },
  itemVideo: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  itemDescription: {
    textAlign: 'left'
  },
  itemGuests: {
    textAlign: 'left'
  },
  itemDuration: {
    textAlign: 'left'
  },
})
export default withStyles(styles)(ReplayPlayer);



// WEBPACK FOOTER //
// ./src/components/Replays/ReplayPlayer.jsx